import { IoMapOutline } from "react-icons/io5";
import RegionCreateModal from "../Modal/RegionCreateModal";
import RegionListPage from "./RegionListPage";

const columns = [
  { header: "Area Name", key: "area" },
  { header: "Area Id", key: "areaId" },
  { header: "State", key: "state" },
  { header: "Created By", key: "createdBy" },
  { header: "Location Description", key: "locationDescription" },
];

const Arealist = () => (
  <RegionListPage
    field="area"
    label="Area"
    CreateIcon={IoMapOutline}
    createLabel="Create New Area"
    columns={columns}
    renderCreate={(p) => (
      <RegionCreateModal {...p} tab="Area" fieldName1="state" fieldName2="Area Name" />
    )}
  />
);
export default Arealist;
